import React, { useEffect, useState } from 'react';
import './styles/affiliate-overlay.css';

function AffiliateOverlay({ trigger, onClose, onDismissForever, onNavigate }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animate in
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  const handleDismiss = () => {
    setIsVisible(false);
    setTimeout(() => {
      onDismissForever(trigger);
      onClose();
    }, 300);
  };

  const handleGetLink = () => {
    setIsVisible(false);
    setTimeout(() => {
      onNavigate();
      onClose();
    }, 300);
  };

  const getTriggerContent = () => {
    switch (trigger) {
      case 'automation_5':
        return {
          title: 'That was awesome, right?',
          subtitle: 'You just created your 5th automation! 🎉',
        };
      case 'thread_25':
        return {
          title: 'Wow, that was a productive conversation!',
          subtitle: '25 messages and counting! 💬',
        };
      case 'quick_task':
        return {
          title: 'Lightning fast! ⚡',
          subtitle: 'You completed that in under 60 seconds!',
        };
      default:
        return {
          title: 'That was awesome, right?',
          subtitle: 'You\'re crushing it with Optimus! 🚀',
        };
    }
  };

  const content = getTriggerContent();

  return (
    <div
      className={`affiliate-overlay-backdrop ${isVisible ? 'visible' : ''}`}
      onClick={handleClose}
    >
      <div
        className={`affiliate-overlay-card ${isVisible ? 'visible' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="overlay-close-btn" onClick={handleClose}>
          ✕
        </button>

        <div className="overlay-icon">🚀</div>

        <h2 className="overlay-title">{content.title}</h2>
        <p className="overlay-subtitle">{content.subtitle}</p>

        <div className="overlay-message">
          <p>
            Did you know Optimus can <strong>pay for itself</strong>?
            Share your unique link and earn <strong>30% recurring commission</strong> on
            every person who signs up.
          </p>
        </div>

        <div className="overlay-stats">
          <div className="overlay-stat">
            <div className="overlay-stat-value">30%</div>
            <div className="overlay-stat-label">Recurring Commission</div>
          </div>
          <div className="overlay-stat">
            <div className="overlay-stat-value">Lifetime</div>
            <div className="overlay-stat-label">As Long As They Subscribe</div>
          </div>
          <div className="overlay-stat">
            <div className="overlay-stat-value">$299/mo</div>
            <div className="overlay-stat-label">Per Pro Referral</div>
          </div>
        </div>

        <div className="overlay-actions">
          <button
            className="btn-overlay btn-overlay-primary"
            onClick={handleGetLink}
          >
            Get My Affiliate Link →
          </button>

          <button
            className="btn-overlay btn-overlay-ghost"
            onClick={handleDismiss}
          >
            Don't show this again
          </button>
        </div>
      </div>
    </div>
  );
}

export default AffiliateOverlay;
